var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3865_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.36958 0 0 6.36952 0 14C0 21.6304 6.36952 28 14 28C21.6304 28 28 21.6305 28 14C28 8.18593 24.2747 2.84954 18.8141 0.849876L18.1558 2.64779C22.8988 4.38462 26.0855 8.94672 26.0855 14C26.0855 20.6639 20.6639 26.0855 14 26.0855C7.33606 26.0855 1.91453 20.6639 1.91453 14C1.91453 7.33606 7.33606 1.91453 14 1.91453V0ZM15.6939 0.101546L15.4645 2.00229C15.9199 2.05721 16.3765 2.13908 16.8215 2.24546L17.2666 0.38328C16.7508 0.259972 16.2216 0.165204 15.6939 0.101546ZM14 4.78632C8.91956 4.78632 4.78632 8.91956 4.78632 14C4.78632 19.0804 8.91956 23.2137 14 23.2137C19.854 23.2137 24.3217 17.5629 22.9635 11.8634L21.1012 12.3073C22.1776 16.8243 18.6379 21.2991 14 21.2991C9.97524 21.2991 6.70085 18.0248 6.70085 14C6.70085 9.97524 9.97524 6.70085 14 6.70085C15.6817 6.70085 17.3243 7.28924 18.6251 8.35772L19.8402 6.87836C18.1979 5.52933 16.1238 4.78632 14 4.78632ZM21.7136 7.69142L13.8466 15.5584L10.8908 12.1863L9.45112 13.4482L13.0807 17.5892C13.5662 18.0235 14.1496 17.9637 14.4775 17.6351L23.0674 9.04517L21.7136 7.69142Z",
    fill: "#735BF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3865_4104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.3e96aed98b2d97f035e131e730a63e61.svg";
export { ForwardRef as ReactComponent };